module.exports = __webpack_public_path__ + "components/country-flag/static/ga-882c0b0d9df74a66a377b71d8535c2e1.svg";